import { format as _format } from 'date-fns/format';
import { formatISO as _formatISO } from 'date-fns/formatISO';

import { fromArgs, DATE_FORMAT, toDate } from '.';

type DateInput = Date | number | string;

type Format = {
  (date: DateInput): string;
  (year: number | string, month: number | string, day: number | string): string;
};

/** @deprecated Use `format` from the `useFormatter` hook to render a localized date. Or `formatISO` to transfer a date. */
export const format: Format = (
  dateOrYear: DateInput,
  month?: number | string,
  day?: number | string,
): string => {
  if (month !== undefined && day !== undefined)
    return _format(fromArgs(dateOrYear as number | string, month, day), DATE_FORMAT);
  const value = dateOrYear instanceof Date ? dateOrYear : Number(dateOrYear);
  return _format(value, DATE_FORMAT);
};

/*
 * Returns the date in full ISO 8601 format, e.g. `2022-05-29T12:00:00Z`
 * Main use case is to mock dates as received from Digital Core
 * Note that this is sensitive to local timezones when passing a Date instance,
 * so it's better to pass a string like `2022-05-29`.
 */
export const formatISO = (date?: DateInput): string => {
  const value = toDate(date);
  return value.toISOString().replace(/\.000Z$/, 'Z');
};

/*
 * Returns the date in short ISO 8601 format, e.g. `2022-09-02`
 * Main use case is to send data to e.g. Digital Core or other internal date handling.
 */
export const formatShortISO = (date?: DateInput): string => {
  const value = toDate(date);
  return _formatISO(value, { representation: 'date' });
};
